import head from "./head";

export default { head };
